// Import first, ahead of everything below: if this host is an old
// socialproapp.com domain, this redirects synchronously and nothing past
// this line should get the chance to run first.
import { isRedirectingToNewDomain } from "./app/bootstrap/domainGuard";
import "./app/bootstrap/polyfills";
// Import first: registers the beforeinstallprompt listener before React mounts,
// so the event can't fire-and-be-missed during initial load.
import "./app/bootstrap/pwaInstall";

import ReactDOM from "react-dom/client";

import App from "./App";

if (!isRedirectingToNewDomain) {
  const root = ReactDOM.createRoot(
    document.getElementById("root") as HTMLElement
  );
  root.render(<App />);
}
